import PrimaryPageContainer from "../components/containers/PrimaryPageContainer.jsx";
import HomeHeroSection from "../sections/home/HomeHeroSection.jsx";
import HomeHeroDescription from "../sections/home/HomeHeroDescription.jsx";
import HomeWhyChooseSection from "../sections/home/HomeWhyChooseSection.jsx";
import HomeProductsSection from "../sections/home/HomeProductsSection.jsx";
import HomeValuesSection from "../sections/home/HomeValuesSection.jsx";
import HomeGettingStartedSection from "../sections/home/HomeGettingStartedSection.jsx";
import HomeFooterSection from "../sections/home/HomeFooterSection.jsx";

function HomePage() {
  return (
    <PrimaryPageContainer noChildPadding>
      <HomeHeroSection />
      <HomeHeroDescription />
      <HomeProductsSection />
      <HomeWhyChooseSection />
      <HomeValuesSection />
      <HomeGettingStartedSection />
      <HomeFooterSection />
    </PrimaryPageContainer>
  );
}

export default HomePage;
